import { string, object } from 'yup';

import { DELIVERIES } from 'shared/helpers/constants/deliveries/deliveriesConstants';

export const TransferOuncesWizardSchema = object().shape({
  delivery: string().required(),
  relatedLot: object().required(DELIVERIES.RELATED_LOT_EMPTY).nullable(),
});
